<template>
	<p>
		<strong>{{ destination }}</strong>
		{{ description }}
	</p>
</template>

<script>
export default {
	props: ["destination", "description"],
};
</script>

<style>
</style>